











import { Component, Vue, Prop, Watch, Provide } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import EmptyStateComponentVue from '../components/empty-state/EmptyStateComponent.vue';
import { EventBus } from '../event-bus';
import ProductCountry from '../interfaces/models/ProductCountry';
import { getScopeFromRouter } from '@/router';
import { cloneDeep } from 'apollo-utilities';

const core = namespace('core');
const product = namespace('product');
const filter = namespace('filter');
const references = namespace('references');
const flows = namespace('flows');
const chapters = namespace('chapters');
const localization = namespace('localization');
const presentations = namespace('presentation');
const cart = namespace('cart');

const PRODUCT_ID_BACKUP = null;

@Component({
  components: {
    empty: EmptyStateComponentVue
  }
})
export default class ProductCountryBoundary extends Vue {
  @Prop({ type: String }) product?: string;
  @Prop({ type: String }) country?: string;

  @Provide('pid') pid = this.product;

  @localization.Action('getConfig') getLocalizationConfig!: () => Promise<void>;

  @cart.Mutation('reset') public resetCart!: () => void;

  @core.Action('loadLibSettings') public loadSettings!: () => void;
  @core.Mutation('changeScope') public changeScope!: (values: {
    key: string;
    value: string | undefined;
  }) => void;

  @filter.Action('filterSlides') filterSlides!: () => Promise<void>;
  @filter.Action('filterCollections') filterCollections!: (type: 'flows' | 'chapters') => Promise<void>;
  @presentations.Action('getFlows') getFlows!: (p: ProductCountry) => Promise<void>;
  @presentations.Action('getChapters') getChapters!: (p: ProductCountry) => Promise<void>;

  @flows.Action('setActiveFlow') setActiveFlow!: (f: any) => Promise<void>;
  @chapters.Action('setActiveChapter') setActiveChapter!: (c: any) => Promise<void>;

  @product.Action('setCurrent') setCurrentProductAndCountry!: (a: {
    product: string;
    country: string;
  }) => Promise<void>;

  @references.Action('getAll') getAllReferences!: () => void;

  get isProductAndCountrySet() {
    return !!this.product && !!this.country;
  }

  @Watch('product', { immediate: true })
  @Watch('country', { immediate: true })
  async changedScope(val: string) {
    if (this.isProductAndCountrySet) {
      const scope = getScopeFromRouter();
      if (!scope) return;
      this.changeScope({ key: 'country', value: this.country });
      this.changeScope({ key: 'product', value: this.product });

      await this.setCurrentProductAndCountry(cloneDeep(scope));

      await this.loadSettings();
      await this.getLocalizationConfig();

      this.resetCart();

      this.filterSlides();
      await this.getFlows(scope);
      await this.getChapters(scope);
      await this.filterCollections('flows');
      await this.filterCollections('chapters');

      EventBus.$emit('reload-board', true);

      this.setActiveFlow(null);
      this.setActiveChapter(null);

      this.getAllReferences();
    }
  }
}
